<script>
export default {
    name: 'Illu3points',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-points"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle :stroke="secondaryColor" class="secondary-color" cx="16" cy="48" r="7.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="32" cy="32" r="7.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="48" cy="16" r="7.5" />
            <path
                d="M16 44a4 4 0 110 8 4 4 0 010-8zm16-16a4 4 0 110 8 4 4 0 010-8zm16-16a4 4 0 110 8 4 4 0 010-8z"
                :fill="primaryColor" class="primary-color"
            />
            <path
                :stroke="secondaryColor" class="secondary-color"
                d="M21.5 42.5l5-5M37.5 26.5l5-5M32 56l24-24M48 32h8v8"
            />
        </g>
    </svg>
</template>
